import CloseButton from "components/CloseButton/CloseButton";
import DialogAlert from "components/DialogAlert/DialogAlert";

const SessionPopup = ({
    updateActivityPopup,
    variant,
    children
}) => {

    const toggleShow = () =>{
        updateActivityPopup.popup.hide();
    }     

    return(
        <DialogAlert
            show={updateActivityPopup.popup.value}
            toggleShow={toggleShow}
            variant={variant}>
            <CloseButton onClick={toggleShow}/> 
            {children}
        </DialogAlert>
    )
}

export default SessionPopup;
